import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const CrackOutlinedSvg = () => (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.9}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3.5" y="3.5" width="17" height="17" rx="3" />
    <polyline points="12.5,3.5 10,9 13.5,12.5 10.5,17 12,20.5" />
  </svg>
);

export const CrackOutlined = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CrackOutlinedSvg} {...props} />
);
